import { gql } from "@apollo/client";
import { BaseAnimalMutationResponse } from "./createAnimalInfoCall";
import { PANEL_ANIMAL_FRAGMENT } from "./getAnimalCall";


export const MAINTAIN_ANIMAL_INFO = gql`
  mutation Maintain($domain: String!, $animals: [MaintainAnimal!]!, $ifFeedCurveBaseInfoOnly: Boolean!, $ifFeedCurveInfo: Boolean!, $ifSpreading: Boolean!, $ifSkipConsumption: Boolean!, $ifSkipLastTenDaysConsumption: Boolean!) {
    animal {
      maintain(domain: $domain, animals: $animals) {
        code
        success
        message
        updatedValues {
          ...AnimalFields
        } 
      }
    }
  }
  ${PANEL_ANIMAL_FRAGMENT}
`

export interface MaintainAnimalsResponse {
  animal: {
    maintain: BaseAnimalMutationResponse
  }
}

export interface MaintainAnimal {
  animal_id: number;
  feedcurve_id?: number;
  cycle?: number;
  location?: number;
  animal_number?: number;
  correction?: number;
  condition?: number;
  animal_type?: number;
  responder_number?: string | null;
  animal_group_id?: number;
  fk_feedcurve_milestones?: number;
  milestone_day?: number;
  life_number?: number;
  birthday?: number;
  deleted?: boolean;
  reset_consumption?: number;
}